export default __webpack_public_path__ + "static/media/under-maintenance.ebe935b8.jpg";